import { useNavigate, Navigate } from 'react-router-dom';
import ProfilePanel from '../components/ProfilePanel';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function OrdersPage() {
  const navigate = useNavigate();
  const {
    currentUser,
    cartQty,
    trackingOrderId,
    setTrackingOrderId,
    handleLogout,
  } = useAppContext();

  if (!currentUser) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return (
    <ProfilePanel
      user={currentUser}
      onClose={() => navigate(ROUTES.HOME)}
      initialTab="orders"
      trackingOrderId={trackingOrderId}
      onOpenCart={() => navigate(ROUTES.CART)}
      cartCount={cartQty}
      onClearTrackingId={() => setTrackingOrderId(null)}
      onHelp={() => navigate(ROUTES.HELP)}
      onLogout={handleLogout}
      onAddressPickerChange={() => {}}
    />
  );
}

export default OrdersPage;
